import Link from "@material-ui/core/Link";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { Fragment, useState, useEffect } from "react";
import Auth from "../auth/auth";
import { LanguageContext } from "../containers/languageprovider";
//import globalStyles from './globalStyles';
import { Button, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Snackbar from "@material-ui/core/Snackbar";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Grid } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";
import MuiAlert from "@material-ui/lab/Alert";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { returnStringTranslation } from "./printLanguageSelect";
import { HourList, getFloorText } from "./utils";
import NumberFormat from "react-number-format";
import {
  BUILDING_FORM_REQUEST,
  BUILDING_FORM_APPOINTMENT,
  BUILDING_FORM_PROPERTY_INSPECTION,
  PRIVACY_COOKIE_URL_IT,
  PRIVACY_COOKIE_URL_EN, TERMS_AND_CONDITIONS_URL_IT, TERMS_AND_CONDITIONS_URL_EN,
} from "../config/config";
import { dictionaryList } from "./languages";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  LinkTerm: {
    textDecoration: "underline",
  },

  privacyText: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "10px",
    lineHeight: "13px",
    color: "#B6B6B6",
    marginTop: "8px",
    marginBottom: "4px",
  },



  marginForm: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "6px",
    },

    '& .MuiInputBase-input': {
      height: '17px',
    },
    '& .MuiInputBase-inputMultiline': {
      height: '34px',
      overflow: 'auto',
    },
    marginTop: "7px",
    marginBottom: "2px",
  },
  privacyTextCheck: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    color: "#6A6A6A",
  },

  buildingTextCheck: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",

    boxSizing: "border-box",
    borderRadius: "10px",
    marginTop: "10px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "4px",

    border: "1px solid #B6B6B6",
    color: "#6A6A6A",
  },

  buildingTextChecked: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "16px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    marginTop: "10px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "4px",

    background: "rgba(28, 85, 229, 0.1)",
    border: "1px solid #1C55E5",
    boxSizing: "border-box",
    borderRadius: "10px",
    color: "#1C55E5",
  },
}));

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export default function   RequestInformationForm(props) {
  const history = useHistory();
  const { dictionary, userLanguage } = React.useContext(LanguageContext);
  const user = Auth.getUser();
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [AlertOpen, setAlertOpen] = useState(false);
  const [alertseverity, setAlertSeverity] = React.useState("success");
  const [alertmsg, setAlertMsg] = React.useState(false);
  const [buildingsselect, setbuildingsselect] = useState([]);
  const [checkUpdate, setCheckUpdate] = useState(0);
  const [formState, setFormState] = useState(1);
  const [commercial, SetCommercial] = useState(false);
  const [values, setValues] = useState({
    name: user ? user.name : "",
    surname: user ? user.surname : "",
    email: user ? user.email : "",
    companyname: user ? user.companyname : "",
    phonenumber: user ? user.mobilephone : "",
    accept_privacy: false,
    accept_info: false,
    request_appointment_date: null,
    TimeSlot: null,
  });

  const [formState1, setFormState1] = useState({
    message: dictionary.placeholderMessage,
    name: "",
    email: "",
    phone: "",
    solution: [],
  });

  const [formState2, setFormState2] = useState({
    day: null,
    time_slot: "",
    name: "",
    email: "",
    phone: "",
    solution: [],
  });
  const [formState3, setFormState3] = useState({
    message: dictionary.propInspPlaceholder,
    name: "",
    email: "",
    phone: "",
    solution: [],
  });

  // FORM ERROR STATES

  const [form1Error, setForm1Error] = useState({
    name: {
      error: false,
      message: "",
    },
    email: {
      error: false,
      message: "",
    },
    phone: {
      error: false,
      message: "",
    },
    message: {
      error: false,
      message: "",
    },
    solution: {
      error: false,
      message: "",
    },
  });
  const [form2Error, setForm2Error] = useState({
    day: {
      error: false,
      message: "",
    },
    time_slot: {
      error: false,
      message: "",
    },
    name: {
      error: false,
      message: "",
    },
    email: {
      error: false,
      message: "",
    },
    solution: {
      error: false,
      message: "",
    },
    phone: {
      error: false,
      message: "",
    },
  });
  const [form3Error, setForm3Error] = useState({
    name: {
      error: false,
      message: "",
    },
    email: {
      error: false,
      message: "",
    },
    phone: {
      error: false,
      message: "",
    },
    message: {
      error: false,
      message: "",
    },
    solution: {
      error: false,
      message: "",
    },
  });

  useEffect(() => {
    setFormState1((formState1) => ({
      ...formState1,
      name: values.name,
      email: values.email,
      phone: values.phonenumber,
    }));

    setFormState2((formState2) => ({
      ...formState2,
      name: values.name,
      email: values.email,
      phone: values.phonenumber,
    }));

    setFormState3((formState3) => ({
      ...formState3,
      name: values.name,
      email: values.email,
      phone: values.phonenumber,
    }));
  }, [values]);

  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  const handleChangeTimeSlot = (event) => {
    setValues({
      ...values,
      TimeSlot: event.target.value,
    });
  };

  const handleChangedate = (event) => {
    setFormState2({
      ...formState2,
      day: moment(event).format("YYYY-MM-DD"),
    });
  };

  const handleCheck = (event) => {
    setValues({ ...values, [event.target.name]: event.target.checked });
  };

  const handleCheckBuildSelect = (event) => {
    let newbuildingselect = buildingsselect;

    if (event.target.checked) {
      newbuildingselect.push(event.target.value);
    } else {
      newbuildingselect.splice(
        newbuildingselect.indexOf(event.target.value),
        1
      );
    }
    setbuildingsselect(newbuildingselect);
    setCheckUpdate(checkUpdate + 1);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleAlertOpen = (title, msg) => {
    setAlertSeverity(title);
    setAlertMsg(msg);
    setAlertOpen(true);
  };

  const SendRequest = async (e) => {
    e.preventDefault();

    setLoading(true);
    if (formState === 1) {
      const unitsString = formState1.solution.map((s) => s.id).toString();
      const reqBody = {
        remote_ip: null,
        user_id: Auth.getUser()?.id ?? null,
        form: {
          message: formState1.message,
          name: formState1.name,
          email: formState1.email,
          phone: formState1.phone,
          solution: unitsString,
          commercial: commercial,
        },
      };
      try {
        const res = await axios.post(BUILDING_FORM_REQUEST, reqBody, {
          params: { language: userLanguage },
        });
        setAlertSeverity("success");
        setAlertMsg(res.data.message);
        setAlertOpen(true);
        setForm1Error({
          name: {
            error: false,
            message: "",
          },
          email: {
            error: false,
            message: "",
          },
          phone: {
            error: false,
            message: "",
          },
          message: {
            error: false,
            message: "",
          },
          solution: {
            error: false,
            message: "",
          },
        });
      } catch (err) {
        setForm1Error({
          name: {
            error: err.response.data.errors?.name ? true : false,
            message: err.response.data.errors?.name ?? "",
          },
          email: {
            error: err.response.data.errors?.email ? true : false,
            message: err.response.data.errors?.email ?? "",
          },
          phone: {
            error: err.response.data.errors?.phone ? true : false,
            message: err.response.data.errors?.phone ?? "",
          },
          message: {
            error: err.response.data.errors?.message ? true : false,
            message: err.response.data.errors?.message ?? "",
          },
          solution: {
            error: err.response.data.errors?.solution ? true : false,
            message: err.response.data.errors?.solution ?? "",
          },
        });
        setAlertSeverity("error");
        setAlertMsg(err.response.data.message);
        setAlertOpen(true);
      }
    }
    if (formState === 2) {
      const unitsString = formState2.solution.map((s) => s.id).toString();
      const reqBody = {
        remote_ip: null,
        user_id: Auth.getUser()?.id ?? null,
        form: {
          day: formState2.day,
          time_slot: formState2.time_slot,
          email: formState2.email,
          name: formState2.name,
          phone: formState2.phone,
          solution: unitsString,
          commercial: commercial,
        },
      };
      try {
        const res = await axios.post(BUILDING_FORM_APPOINTMENT, reqBody, {
          params: { language: userLanguage },
        });
        setAlertSeverity("success");
        setAlertMsg(res.data.message);

        setAlertOpen(true);
        setForm2Error({
          day: {
            error: false,
            message: "",
          },
          time_slot: {
            error: false,
            message: "",
          },
          name: {
            error: false,
            message: "",
          },
          email: {
            error: false,
            message: "",
          },
          solution: {
            error: false,
            message: "",
          },
          phone: {
            error: false,
            message: "",
          },
        });
      } catch (err) {
        setForm2Error({
          day: {
            error: err.response.data.errors?.day ? true : false,
            message: err.response.data.errors?.day ?? "",
          },
          time_slot: {
            error: err.response.data.errors?.time_slot ? true : false,
            message: err.response.data.errors?.time_slot ?? "",
          },
          name: {
            error: err.response.data.errors?.name ? true : false,
            message: err.response.data.errors?.name ?? "",
          },
          email: {
            error: err.response.data.errors?.email ? true : false,
            message: err.response.data.errors?.email ?? "",
          },
          phone: {
            error: err.response.data.errors?.phone ? true : false,
            message: err.response.data.errors?.phone ?? "",
          },

          solution: {
            error: err.response.data.errors?.solution ? true : false,
            message: err.response.data.errors?.solution ?? "",
          },
        });
        setAlertSeverity("error");
        setAlertMsg(err.response.data.message);
        setAlertOpen(true);
      }
    }
    if (formState === 3) {
      const unitsString = formState3.solution.map((s) => s.id).toString();
      const reqBody = {
        remote_ip: null,
        user_id: Auth.getUser()?.id ?? null,
        form: {
          message: formState3.message,
          name: formState3.name,
          email: formState3.email,
          phone: formState3.phone,
          solution: unitsString,
          commercial: commercial,
        },
      };
      try {
        const res = await axios.post(
          BUILDING_FORM_PROPERTY_INSPECTION,
          reqBody,
          {
            params: { language: userLanguage },
          }
        );
        setAlertSeverity("success");
        setAlertMsg(res.data.message);
        setAlertOpen(true);
        setForm3Error({
          name: {
            error: false,
            message: "",
          },
          email: {
            error: false,
            message: "",
          },
          phone: {
            error: false,
            message: "",
          },
          message: {
            error: false,
            message: "",
          },
          solution: {
            error: false,
            message: "",
          },
        });
      } catch (err) {
        setForm3Error({
          name: {
            error: err.response.data.errors?.name ? true : false,
            message: err.response.data.errors?.name ?? "",
          },
          email: {
            error: err.response.data.errors?.email ? true : false,
            message: err.response.data.errors?.email ?? "",
          },
          phone: {
            error: err.response.data.errors?.phone ? true : false,
            message: err.response.data.errors?.phone ?? "",
          },
          message: {
            error: err.response.data.errors?.message ? true : false,
            message: err.response.data.errors?.message ?? "",
          },
          solution: {
            error: err.response.data.errors?.solution ? true : false,
            message: err.response.data.errors?.solution ?? "",
          },
        });
        setAlertSeverity("error");
        setAlertMsg(err.response.data.message);
        setAlertOpen(true);
      }
    }

    setLoading(false);
    return;

    //console.log(options);
    if (values.name === "" || values.surname === "") {
      setLoading(false);
      handleAlertOpen("warning", dictionary.InvalidNameSurname);
      return;
    }

    if (values.email === "") {
      setLoading(false);
      handleAlertOpen("warning", dictionary.EmailRequired);
      return;
    }

    if (
      props.buildinglist !== false &&
      props.buildinglist !== undefined &&
      buildingsselect.length === 0
    ) {
      setLoading(false);
      handleAlertOpen("warning", dictionary.SelectASolution);
      return;
    }

    if (values.accept_privacy === false) {
      setLoading(false);
      handleAlertOpen("warning", dictionary.AcceptAlert);
      return;
    }

    if (values.accept_info === false) {
      setLoading(false);

      handleAlertOpen("warning", dictionary.AcceptToContinue);
      return;
    }

    let message = "";
    if (props.buildinglist !== false && props.buildinglist !== undefined) {
      message = dictionary.AskforinformationInterest + ": \n";
      props.buildinglist.forEach((element) => {
        if (element !== false) {
          message += returnStringTranslation(element.name, userLanguage) + "\n";
        }
      });
    } else {
      message =
        returnStringTranslation(props.building.name, userLanguage) +
        "\n" +
        (values.request_appointment_date !== null
          ? dictionary.ProposeAppointment +
            ": " +
            moment(values.request_appointment_date).format("DD/MM/YYYY") +
            "\n"
          : "") +
        (values.TimeSlot !== null
          ? dictionary.TimeSlot + ": " + values.TimeSlot
          : "");
    }

    //dictionary.AskforinformationInterest
    /*name:user ? user.name:"" ,
    surname:user ? user.surname:"" ,
    email:user ? user.email:"" ,
    companyname:user ? user.companyname:"" ,
    phonenumber:user ? user.mobilephone:"" ,
    accept_privacy:false,*/

    /*let message= dictionary.Iminterestedin;
    options.forEach(element => {
        message+= returnStringTranslation(element.name,userLanguage)+" ";
    });*/

    try {
      axios
        .post(
          "https://api.hsforms.com/submissions/v3/integration/submit/20219665/7433d2fb-452c-4d8c-840b-5d1971cd1d31",
          {
            fields: [
              {
                name: "email",
                value: values.email,
              },
              {
                name: "firstname",
                value: values.name,
              },
              {
                name: "lastname",
                value: values.surname,
              },
              {
                name: "company",
                value: "",
              },
              {
                name: "phone",
                value: values.phonenumber,
              },
              {
                name: "message",
                value: message,
              },
            ],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((payload) => {
          setLoading(false);
          if (
            props.buildinglist === false ||
            props.buildinglist === undefined
          ) {
            history.push("/thankyou/" + props.building.slug);
          } else {
            handleAlertOpen("success", dictionary.RequestSended);
            props.onSend();
          }
        })
        .catch((error) => {
          setLoading(false);
          handleAlertOpen("error", dictionary.FieldIncomplete);
        });
    } catch (e) {
      setLoading(false);
      handleAlertOpen("error", dictionary.FieldIncomplete);
    }
  };

  const handleFormState = (event) => {
    setFormState(event.target.value);
  };

  const handleChange1 = (prop) => (event) => {
    setFormState1((values) => ({
      ...values,
      [prop]: event.target.value,
    }));
  };
  const handleChange2 = (prop) => (event) => {
    setFormState2((values) => ({
      ...values,
      [prop]: event.target.value,
    }));
  };
  const handleChange3 = (prop) => (event) => {
    setFormState3((values) => ({
      ...values,
      [prop]: event.target.value,
    }));
  };

  const [hasSelectedAll1, setHasSelectedAll1] = React.useState(false);
  const [hasSelectedAll2, setHasSelectedAll2] = React.useState(false);
  const [hasSelectedAll3, setHasSelectedAll3] = React.useState(false);

  const handleSolutionChange = (prop) => (event) => {
    if (prop === 1) {
      if (event.target.value.indexOf("all") > -1) {
        if (!hasSelectedAll1) {
          setFormState1((values) => ({
            ...values,
            solution: props.listunits,
          }));
          setHasSelectedAll1(true);
        } else {
          setFormState1((values) => ({
            ...values,
            solution: [],
          }));
          setHasSelectedAll1(false);
        }
      } else {
        setFormState1((values) => ({
          ...values,
          solution: event.target.value,
        }));
      }
    }
    if (prop === 2) {
      if (event.target.value.indexOf("all") > -1) {
        if (!hasSelectedAll2) {
          setFormState2((values) => ({
            ...values,
            solution: props.listunits,
          }));
          setHasSelectedAll2(true);
        } else {
          setFormState2((values) => ({
            ...values,
            solution: [],
          }));
          setHasSelectedAll2(false);
        }
      } else {
        setFormState2((values) => ({
          ...values,
          solution: event.target.value,
        }));
      }
    }
    if (prop === 3) {
      if (event.target.value.indexOf("all") > -1) {
        if (!hasSelectedAll3) {
          setFormState3((values) => ({
            ...values,
            solution: props.listunits,
          }));
          setHasSelectedAll3(true);
        } else {
          setFormState3((values) => ({
            ...values,
            solution: [],
          }));
          setHasSelectedAll3(false);
        }
      } else {
        setFormState3((values) => ({
          ...values,
          solution: event.target.value,
        }));
      }
    }
  };

  const handleCheckboxChange = (prop) => (event) => {
    if (prop === 1) {
      if (event.target.checked) {
        setFormState1({
          ...formState1,
          solution: props.listunits,
        });
      }
    }
    if (prop === 2) {
      if (event.target.checked) {
        setFormState2({
          ...formState2,
          solution: props.listunits,
        });
      } else {
        setFormState2({
          ...formState2,
          solution: [],
        });
      }
    }
    if (prop === 3) {
      if (event.target.checked) {
        setFormState3({
          ...formState3,
          solution: props.listunits,
        });
      } else {
        setFormState3({
          ...formState3,
          solution: [],
        });
      }
    }
  };

  return (
    <form
      ref={props.elemRef}
      className={classes.form}
      noValidate
      onSubmit={SendRequest}
    >
      <input name="hiddenInput" value={checkUpdate} type="hidden" />

      <FormControl
        required
        fullWidth
        variant="outlined"
        className={classes.marginForm}
      >
        <InputLabel id="demo-simple-select-outlined-label">{dictionary.Request}</InputLabel>
        <Select
          value={formState}
          onChange={handleFormState}
          label={dictionary.TimeSlot}
          required
        >
          <MenuItem value={1}>{dictionary.regInfo}</MenuItem>
          <MenuItem value={2}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item> {dictionary.suggestApp}</Grid>
              <Grid item>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">
                        {dictionary.helpAppointments}
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <img src="/images/ico/InfoIcon.svg" />
                </HtmlTooltip>
              </Grid>
            </Grid>
          </MenuItem>
          <MenuItem value={3}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item>{dictionary.reqPropInsp}</Grid>
              <Grid item>
                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">
                        {dictionary.requestInspectionTooltip}
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <img src="/images/ico/InfoIcon.svg" />
                </HtmlTooltip>
              </Grid>
            </Grid>
          </MenuItem>
        </Select>
      </FormControl>

      {formState === 1 && (
        <>
          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            maxRows={2}
            multiline
            error={form1Error.message.error}
            helperText={form1Error.message.message}
            required
            fullWidth
            id="message"
            placeholder={dictionary.placeholderMessage}
            // defaultValue={dictionary.placeholderMessage}
            label={dictionary.message}
            name="message"
            value={formState1.message}
            onChange={handleChange1("message")}
          />

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="name"
            label={dictionary.nameSurname}
            error={form1Error.name.error}
            helperText={form1Error.name.message}
            name="name"
            value={formState1.name}
            onChange={handleChange1("name")}
          />

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={form1Error.email.error}
            helperText={form1Error.email.message}
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={formState1.email}
            onChange={handleChange1("email")}
          />
          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={form1Error.phone.error}
            helperText={form1Error.phone.message}
            id="phone"
            label={dictionary.phoneNumberC}
            name="phone"
            autoComplete="phone"
            value={formState1.phone}
            onChange={handleChange1("phone")}
          />
          <FormControl
            required
            fullWidth
            variant="outlined"
            className={classes.marginForm}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {dictionary.solutionsHeaderC}
            </InputLabel>
            <Select
              multiple
              error={form1Error.solution.error}
              helperText={form1Error.solution.message}
              value={formState1.solution}
              onChange={handleSolutionChange(1)}
              label={dictionary.solutionsHeader}
              required
              renderValue={(selected) => (
                  <div
                      style={{
                        display: "flex",
                        justifyContent:"space-around",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                  >
                    {selected.length > 0 &&  <div >
                      {getFloorText(selected[0].floor, dictionary, userLanguage)}| {" "}
                      <NumberFormat
                          fixedDecimalScale="true"
                          decimalScale="2"
                          value={selected[0].size}
                          type="text"
                          displayType="text"
                          thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"} {" "}
                    </div>
                    } {selected.length > 1 && <span style={{fontWeight: "500", color: "#1c55e5"}} >+{selected.length - 1}</span>}
                  </div>
              )}
            >
              {" "}
              <MenuItem key="all" value="all">
                <Grid container alignItems="center">
                  <Grid item>
                    <Checkbox
                      color="primary"
                      // onChange={handleCheckboxChange(1)}
                      checked={
                        formState1.solution.length === props.listunits.length
                      }
                    />
                  </Grid>
                  <Grid item>{dictionary.selectAllUnits}</Grid>
                </Grid>
              </MenuItem>
              {props.listunits.map((unit) => (
                <MenuItem key={unit.id} value={unit}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <Checkbox
                        color="primary"
                        // onChange={handleCheckboxChange(1)}
                        checked={formState1.solution.indexOf(unit) > -1}
                      />
                    </Grid>
                    <Grid item>
                      {/*{returnStringTranslation(unit.name, userLanguage)} |{" "}*/}
                      {getFloorText(unit.floor, dictionary, userLanguage)} | {" "}
                      <NumberFormat
                        fixedDecimalScale="true"
                        decimalScale="2"
                        value={unit.size}
                        type="text"
                        displayType="text"
                        thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"} {" "}
                      {/*{getFloorText(unit.floor, dictionary, userLanguage)} |{" "}*/}
                      {/*{unit.deal_type === 2 && dictionary.sale}*/}
                      {/*{unit.deal_type === 1 && dictionary.lease} |{" "}*/}
                      {/*{unit.asset_class === 1 && dictionary.Office}*/}
                      {/*{unit.asset_class === 2 && dictionary.Retail}*/}
                      {/*{unit.asset_class === 3 && dictionary.Industrial}*/}
                    </Grid>
                  </Grid>{" "}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: "#f44336" }}>
              {form1Error.solution.message}
            </FormHelperText>
          </FormControl>
          {/* <Grid container alignItems="center">
            <Grid item>
              <Checkbox
                color="primary"
                onChange={handleCheckboxChange(1)}
                defaultChecked={false}
                checked={formState1.solution.length === props.listunits.length}
              />
            </Grid>{" "}
            <Grid style={{ color: "#212121", fontSize: "14px" }} item>
              {dictionary.selectAllUnits}
            </Grid>
          </Grid> */}
          {props.buildinglist !== undefined && props.buildinglist !== false && (
            <Fragment>
              <Typography>{dictionary.Askforinformation}</Typography>
              {props.buildinglist.map((single) => (
                <Fragment>
                  {single !== false && (
                    <FormControlLabel
                      key={single.id}
                      control={
                        <Checkbox
                          checked={
                            buildingsselect.filter(
                              (buid) => Number(buid) === Number(single.id)
                            ).length > 0
                          }
                          onChange={handleCheckBuildSelect}
                          value={single.id}
                          color="primary"
                        />
                      }
                      label={returnStringTranslation(single.name, userLanguage)}
                      className={
                        buildingsselect.filter(
                          (buid) => Number(buid) === Number(single.id)
                        ).length > 0
                          ? classes.buildingTextChecked
                          : classes.buildingTextCheck
                      }
                    />
                  )}
                </Fragment>
              ))}
            </Fragment>
          )}
        </>
      )}
      {formState === 2 && (
        <>
          <KeyboardDatePicker
            className={classes.marginForm}
            label={dictionary.Date}
            value={formState2.day}
            onChange={handleChangedate}
            error={form2Error.day.error}
            helperText={form2Error.day.message}
            format="dd/MM/yyyy"
            clearLabel={dictionary.Confirm}
            cancelLabel={dictionary.Abort}
            name="request_appointment_date"
            fullWidth
            inputVariant="outlined"
            minDate={moment().add(1, "days")}
          />

          <FormControl
            required
            fullWidth
            variant="outlined"
            className={classes.marginForm}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {dictionary.TimeSlot}
            </InputLabel>
            <Select
              error={form2Error.time_slot.error}
              value={formState2.time_slot}
              onChange={(event) =>
                setFormState2({
                  ...formState2,
                  time_slot: event.target.value,
                })
              }
              label={dictionary.TimeSlot}
              required
            >
              {HourList.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: "#f44336" }}>
              {form2Error.time_slot.message}
            </FormHelperText>
          </FormControl>

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            error={form2Error.name.error}
            helperText={form2Error.name.message}
            required
            fullWidth
            id="name"
            label={dictionary.nameSurname}
            name="name"
            value={formState2.name}
            onChange={handleChange2("name")}
          />

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            error={form2Error.email.error}
            helperText={form2Error.email.message}
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={formState2.email}
            onChange={handleChange2("email")}
          />
          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            error={form2Error.phone.error}
            helperText={form2Error.phone.message}
            id="phone"
            label={dictionary.phoneNumberC}
            name="phone"
            autoComplete="phone"
            value={formState2.phone}
            onChange={handleChange2("phone")}
          />
          <FormControl
            required
            fullWidth
            variant="outlined"
            className={classes.marginForm}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {dictionary.solutionsHeaderC}
            </InputLabel>
            <Select
              multiple
              error={form2Error.solution.error}
              helperText={form2Error.solution.message}
              value={formState2.solution}
              onChange={handleSolutionChange(2)}
              label={dictionary.solutionsHeader}
              required
              renderValue={(selected) => (
                  <div
                      style={{
                        display: "flex",
                        justifyContent:"space-around",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                  >
                    {selected.length > 0 &&  <div >
                      {getFloorText(selected[0].floor, dictionary, userLanguage)}| {" "}
                      <NumberFormat
                          fixedDecimalScale="true"
                          decimalScale="2"
                          value={selected[0].size}
                          type="text"
                          displayType="text"
                          thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"} {" "}
                    </div>
                    } {selected.length > 1 && <span style={{fontWeight: "500", color: "#1c55e5"}} >+{selected.length - 1}</span>}
                  </div>
              )}
            >
              {" "}
              <MenuItem key="all" value="all">
                <Grid container alignItems="center">
                  <Grid item>
                    <Checkbox
                      color="primary"
                      // onChange={handleCheckboxChange(1)}
                      checked={
                        formState2.solution.length === props.listunits.length
                      }
                    />
                  </Grid>
                  <Grid item>{dictionary.selectAllUnits}</Grid>
                </Grid>
              </MenuItem>
              {props.listunits.map((unit) => (
                <MenuItem key={unit.id} value={unit}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <Checkbox
                        color="primary"
                        // onChange={handleCheckboxChange(1)}
                        checked={formState2.solution.indexOf(unit) > -1}
                      />
                    </Grid>
                    <Grid item>
                      {/*{returnStringTranslation(unit.name, userLanguage)} |{" "}*/}
                      {getFloorText(unit.floor, dictionary, userLanguage)}| {" "}
                      <NumberFormat
                        fixedDecimalScale="true"
                        decimalScale="2"
                        value={unit.size}
                        type="text"
                        displayType="text"
                        thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"}
                      {/*|{" "}*/}

                      {/*{unit.deal_type === 2 && dictionary.sale}*/}
                      {/*{unit.deal_type === 1 && dictionary.lease} |{" "}*/}
                      {/*{unit.asset_class === 1 && dictionary.Office}*/}
                      {/*{unit.asset_class === 2 && dictionary.Retail}*/}
                      {/*{unit.asset_class === 3 && dictionary.Industrial}*/}
                    </Grid>
                  </Grid>{" "}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: "#f44336" }}>
              {form2Error.solution.message}
            </FormHelperText>
          </FormControl>

          {props.buildinglist !== undefined && props.buildinglist !== false && (
            <Fragment>
              <Typography>{dictionary.Askforinformation}</Typography>
              {props.buildinglist.map((single) => (
                <Fragment>
                  {single !== false && (
                    <FormControlLabel
                      key={single.id}
                      control={
                        <Checkbox
                          checked={
                            buildingsselect.filter(
                              (buid) => Number(buid) === Number(single.id)
                            ).length > 0
                          }
                          onChange={handleCheckBuildSelect}
                          value={single.id}
                          color="primary"
                        />
                      }
                      label={returnStringTranslation(single.name, userLanguage)}
                      className={
                        buildingsselect.filter(
                          (buid) => Number(buid) === Number(single.id)
                        ).length > 0
                          ? classes.buildingTextChecked
                          : classes.buildingTextCheck
                      }
                    />
                  )}
                </Fragment>
              ))}
            </Fragment>
          )}
        </>
      )}
      {formState === 3 && (
        <>
          <TextField
            className={classes.marginForm}
            variant="outlined"
            multiline
            margin="normal"
            maxRows={2}
            required
            fullWidth
            error={form3Error.message.error}
            helperText={form3Error.message.message}
            id="message"
            placeholder={dictionary.placeholderMessage}
            label={dictionary.message}
            name="message"
            value={formState3.message}
            onChange={handleChange3("message")}
          />

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            error={form3Error.name.error}
            helperText={form3Error.name.message}
            required
            fullWidth
            id="name"
            label={dictionary.nameSurname}
            name="name"
            value={formState3.name}
            onChange={handleChange3("name")}
          />

          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            error={form3Error.email.error}
            helperText={form3Error.email.message}
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            value={formState3.email}
            onChange={handleChange3("email")}
          />
          <TextField
            className={classes.marginForm}
            variant="outlined"
            margin="normal"
            required
            error={form3Error.phone.error}
            helperText={form3Error.phone.message}
            fullWidth
            id="phone"
            label={dictionary.phoneNumberC}
            name="phone"
            autoComplete="phone"
            value={formState3.phone}
            onChange={handleChange3("phone")}
          />
          <FormControl
            required
            fullWidth
            variant="outlined"
            className={classes.marginForm}
          >
            <InputLabel id="demo-simple-select-outlined-label">
              {dictionary.solutionsHeaderC}
            </InputLabel>
            <Select
              multiple
              error={form3Error.solution.error}
              helperText={form3Error.solution.message}
              value={formState3.solution}
              onChange={handleSolutionChange(3)}
              label={dictionary.solutionsHeader}
              required
              renderValue={(selected) => (
                  <div
                      style={{
                        display: "flex",
                        justifyContent:"space-around",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                  >
                    {selected.length > 0 &&  <div >
                      {getFloorText(selected[0].floor, dictionary, userLanguage)}| {" "}
                      <NumberFormat
                          fixedDecimalScale="true"
                          decimalScale="2"
                          value={selected[0].size}
                          type="text"
                          displayType="text"
                          thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"} {" "}
                    </div>
                    } {selected.length > 1 && <span style={{fontWeight: "500", color: "#1c55e5"}} >+{selected.length - 1}</span>}
                  </div>
              )}
            >
              {" "}
              <MenuItem key="all" value="all">
                <Grid container alignItems="center">
                  <Grid item>
                    <Checkbox
                      color="primary"
                      // onChange={handleCheckboxChange(1)}
                      checked={
                        formState3.solution.length === props.listunits.length
                      }
                    />
                  </Grid>
                  <Grid item>{dictionary.selectAllUnits}</Grid>
                </Grid>
              </MenuItem>
              {props.listunits.map((unit) => (
                <MenuItem key={unit.id} value={unit}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <Checkbox
                        color="primary"
                        // onChange={handleCheckboxChange(1)}
                        checked={formState3.solution.indexOf(unit) > -1}
                      />
                    </Grid>
                    <Grid item>
                      {/*{returnStringTranslation(unit.name, userLanguage)} |{" "}*/}
                      {getFloorText(unit.floor, dictionary, userLanguage)} |{" "}
                      <NumberFormat
                        fixedDecimalScale="true"
                        decimalScale="2"
                        value={unit.size}
                        type="text"
                        displayType="text"
                        thousandSeparator={userLanguage === "gb" ? "," : "'"}
                      />{" "}
                      {userLanguage === "gb" ? "Mq" : "m²"}
                      {/*|{" "}*/}
                      {/*{unit.deal_type === 2 && dictionary.sale}*/}
                      {/*{unit.deal_type === 1 && dictionary.lease} |{" "}*/}
                      {/*{unit.asset_class === 1 && dictionary.Office}*/}
                      {/*{unit.asset_class === 2 && dictionary.Retail}*/}
                      {/*{unit.asset_class === 3 && dictionary.Industrial}*/}
                    </Grid>
                  </Grid>{" "}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: "#f44336" }}>
              {form3Error.solution.message}
            </FormHelperText>
          </FormControl>

          {props.buildinglist !== undefined && props.buildinglist !== false && (
            <Fragment>
              <Typography>{dictionary.Askforinformation}</Typography>
              {props.buildinglist.map((single) => (
                <Fragment>
                  {single !== false && (
                    <FormControlLabel
                      key={single.id}
                      control={
                        <Checkbox
                          checked={
                            buildingsselect.filter(
                              (buid) => Number(buid) === Number(single.id)
                            ).length > 0
                          }
                          onChange={handleCheckBuildSelect}
                          value={single.id}
                          color="primary"
                        />
                      }
                      label={returnStringTranslation(single.name, userLanguage)}
                      className={
                        buildingsselect.filter(
                          (buid) => Number(buid) === Number(single.id)
                        ).length > 0
                          ? classes.buildingTextChecked
                          : classes.buildingTextCheck
                      }
                    />
                  )}
                </Fragment>
              ))}
            </Fragment>
          )}
          {/* {(props.buildinglist === false ||
            props.buildinglist === undefined) && (
            <Fragment>
              <Typography>
                {dictionary.ProposeAnAppointment}

                <HtmlTooltip
                  title={
                    <React.Fragment>
                      <Typography color="inherit">
                        {dictionary.helpAppointments}
                      </Typography>
                    </React.Fragment>
                  }
                >
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </HtmlTooltip>
              </Typography>

              <KeyboardDatePicker
                className={classes.marginForm}
                label={dictionary.Day}
                value={values.request_appointment_date}
                onChange={handleChangedate}
                format="dd/MM/yyyy"
                clearLabel={dictionary.Confirm}
                cancelLabel={dictionary.Abort}
                name="request_appointment_date"
                fullWidth
                inputVariant="outlined"
                minDate={moment().add(1, "days")}
              />
              <FormControl
                required
                fullWidth
                variant="outlined"
                className={classes.marginForm}
              >
                <InputLabel id="demo-simple-select-outlined-label">
                  {dictionary.TimeSlot}
                </InputLabel>
                <Select
                  value={values.TimeSlot}
                  onChange={handleChangeTimeSlot}
                  label={dictionary.TimeSlot}
                  required
                >
                  {HourList.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Fragment>
          )} */}
          {/* <Typography className={classes.privacyText}>
            {dictionary.LegalInfoForm}
          </Typography> */}

          {/* <FormControlLabel
            control={
              <Checkbox
                checked={values.accept_info}
                onChange={handleCheck}
                name="accept_info"
                color="primary"
                required
              />
            }
            label={
              <Fragment>
                {dictionary.LegalInfoForm1 + " "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.LinkTerm}
                  href={
                    userLanguage === "it"
                      ? TERMS_AND_CONDITIONS_URL_IT
                      : TERMS_AND_CONDITIONS_URL_EN
                  }
                >
                  {dictionary.LegalInfoForm2}
                </Link>
                {dictionary.LegalInfoForm3 + " "}
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.LinkTerm}
                  href={
                    userLanguage === "it"
                      ? "/pdf/Privacy_Policy_D4RE_IT.pdf"
                      : "/pdf/Privacy_Policy_D4RE_EN.pdf"
                  }
                >
                  {dictionary.LegalInfoForm4}
                </Link>
              </Fragment>
            }
            className={classes.privacyTextCheck}
          /> */}
        </>
      )}

      <Grid style={{ marginTop: "7px" }} container wrap="nowrap">
        <Grid item>
          <Checkbox
            checked={commercial}
            onChange={() => SetCommercial(!commercial)}
            name="accept_privacy"
            color="primary"
            required
          />
        </Grid>
        <Grid
          item
          style={{ fontSize: "13px", fontFamily: "Barlow", color: "#212121" }}
        >
          {dictionary.Privacy2}
        </Grid>
      </Grid>

      <div
        style={{
          marginTop: "0px",
          marginBottom: "7px",
          color: "#212121",
          fontSize: "10px",
        }}
      >
        {userLanguage === "gb" ? (
          <>
            By clicking on "SEND" I declare that I am of legal age and that I
            accept the{" "}
            <a
              target="_blank"
              href={TERMS_AND_CONDITIONS_URL_EN}
            >
              general conditions
            </a>{" "}
            of use and the{" "}
            <a
              target="_blank"
              href={PRIVACY_COOKIE_URL_EN}
            >
             privacy policy
            </a>
          </>
        ) : (
          <>
            Cliccando su "INVIA" dichiaro di essere maggiorenne e di accettare
            le{" "}
            <a
              target="_blank"
              href={TERMS_AND_CONDITIONS_URL_IT}
            >
              condizioni generali d'uso
            </a>{" "}
            e la{" "}
            <a
              target="_blank"
              href={PRIVACY_COOKIE_URL_IT}

            >
              privacy policy
            </a>
          </>
        )}
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        disabled={loading}
        className={classes.submit}
      >
        {loading ? (
            <CircularProgress color="blue" size={24} />
        ) : (
            dictionary.SendRequest
        )}
      </Button>
      <Snackbar
        open={AlertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity={alertseverity}>
          {alertmsg}
        </Alert>
      </Snackbar>
    </form>
  );
}
